import { api, apiTest } from './config'
import { getToken, setToken, removeToken } from '../store/auth'
import request from './request'

export default {
  filaMedica: {
    cadastrarFilaMedica (data) {
      console.log(data)
      return request({
        url: '/filamedica/cadastrarFilaMedica',
        method: 'post',
        data: data
      })
    },
    atualizarStatusFilaMedica (data) {
      return request({
        url: '/filamedica/atualizarStatusFilaMedica',
        method: 'post',
        data: data
      })
    },
    listarMedicos (idEmpresa, idUnidade) {
      console.log(idEmpresa, idUnidade)
      return request({
        url: `/filamedica/listarMedicos?idEmpresa=${idEmpresa}&idUnidade=${idUnidade}`,
        method: 'get'
      })
    }
  }
}
